import { useState, useEffect, Fragment } from 'react';
import { Card, CardBody, Row, Col, Button, Table, Label } from 'reactstrap';
import classnames from 'classnames';
import Select, { SingleValue } from 'react-select';
import { Search } from 'react-feather';
import { useDispatch } from 'react-redux';
import { AesEncrypt, AesDecrypt, keyPromise } from '../../../Service/crypto';
import webservice from '../../../Service/webservice';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs/Breadcrumbs';
// import moment from 'moment';
import moment from 'moment-timezone';
import api from '../../../api';
import { renderJsonDataTable } from './renderJsonDataTable';

type AuditData = {
  Modified: string;
  Action: string;
  JsonData: any;
  UserName: string;
  Parentid: any;
};

type OptionType = {
  value: string;
  label: string;
};

const Action: OptionType[] = [
  { value: 'ADD', label: 'ADD' },
  { value: 'EDIT', label: 'EDIT' },
  { value: 'DELETE', label: 'DELETE' },
  { value: 'VIEW', label: 'VIEW' },
  { value: 'DOWNLOAD', label: 'DOWNLOAD' },
  { value: 'DOWNLOAD OUTPUT', label: 'DOWNLOAD OUTPUT' },
  { value: 'DOWNLOAD PDF', label: 'DOWNLOAD PDF' },
  { value: 'DOWNLOAD RAW', label: 'DOWNLOAD RAW' },
  { value: 'VIEW COST', label: 'VIEW COST' },
  { value: 'REGENERATE', label: 'REGENERATE' },
  { value: 'CLIENT MAPPING', label: 'CLIENT MAPPING' },
  { value: 'FILE ALLOCATE', label: 'FILE ALLOCATE' },
];

const ReportAudit = () => {
  const dispatch = useDispatch();
  const currentDate = new Date();
  const oneWeekBefore = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const [oneWeekBeforePicker, setOneWeekBeforePicker] = useState<Date | null>(oneWeekBefore);
  const [currentDatePicker, setCurrentDatePicker] = useState<Date | null>(currentDate);
  const [submit, setSubmit] = useState(false);
  const [auditData, setAuditData] = useState<OptionType[]>([]);
  const [auditData1, setAuditData1] = useState<AuditData[]>([]);
  const [selectedAction, setSelectedAction] = useState<string | null>(null);
  const [selectedAudit, setSelectedAudit] = useState<string | null>(null);
  const [scrollInnerCard, setScrollInnerCard] = useState(false);
  const [showResults, setShowResults] = useState(false);
  const [loading, setLoading] = useState(false);
  const [auditSelectError, setAuditSelectError] = useState('');
  const [startDateError, setStartDateError] = useState('');
  const [endDateError, setEndDateError] = useState('');

  const getAuditlogdata = async (data: any): Promise<AuditData[]> => {
    const id = localStorage.id;
    const UserType = localStorage.UserType;
    const key = await keyPromise
    const Data = { id, UserType, data }; // Assuming data is already defined somewhere
    const EncParams = await AesEncrypt(key,Data);
    const res = await api.fetch('api/AuditReport/getAuditLog', {
      method: 'POST',
      body: JSON.stringify({ EncParams })
    }).then((response) => response.json());

    const TempData = await AesDecrypt(key,res);

    TempData.forEach((element: any) => {
      if (element.Modified) {
        const utcDate = moment.utc(element.Modified);
        const localDate = utcDate.tz(moment.tz.guess()).format('MM/DD/YYYY, HH:mm:ss');
        element.Modified = localDate;
      } else {
        element.Modified = 'NA';
      }
    });


    console.log("----------------",TempData);
    
    return TempData;
  };

  const spinnerStyle: React.CSSProperties = {
    position: 'fixed',
    top: '60%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    zIndex: 9999,
    borderRadius: '8px',
    padding: '16px',
  };

  const handleSubmit = async () => {
    setShowResults(true);
    setLoading(true);

    if (!selectedAudit) {
      setAuditSelectError('Please select an audit type');
      setLoading(false);
      return;
    }

    if (!oneWeekBeforePicker) {
      setStartDateError('Please select a start date');
      setLoading(false);
      return;
    }

    if (!currentDatePicker) {
      setEndDateError('Please select an end date');
      setLoading(false);
      return;
    }

    setAuditSelectError('');
    setStartDateError('');
    setEndDateError('');

    const data = {
      table: selectedAudit,
      fromDate: oneWeekBeforePicker,
      toDate: currentDatePicker,
      action: selectedAction,
    };
    setAuditSelectError('');
    const res = await getAuditlogdata(data);


    setAuditData1(res);
    setLoading(false);
  };

  const ReportAuditlog = async () => {
    const response = await api.fetch('api/AuditReport/reportAuditLog', {
      method: 'GET'
    });
    const responseData = await response.json();
    const key = await keyPromise
    const TempData = await AesDecrypt(key,responseData);
    console.log(TempData);
    
    return TempData;
  };

  useEffect(() => {
    const fetchAuditData = async () => {
      try {
        const res1 = await ReportAuditlog();
        const options = res1.map((item: string) => ({
          value: item,
          label: item
            .replace('Log_', ' ')
            .replace(/([A-Z])/g, ' $1')
            .replace(/^./, (str) => str.toUpperCase())
            .replace('Usertype', 'User Type')
            .replace('Usermanagement', 'User Management')
            .replace('Patientdetails', 'Document Upload')
            .replace('Output Patient', 'Patient Output'),
        }));
        setAuditData(options);
      } catch (error) {
        console.error(error);
      }
    };
    fetchAuditData();
  }, []);

  const tableDataStyle: React.CSSProperties = {
    textAlign: 'left',
    color: '#232323',
    backgroundColor: '#f2f2f2',
    padding: '10px',
    borderBottom: '1px solid #7a6362',
    borderTop: '1px solid #7a6362',
    borderLeft: '1px solid #7a6362',
    borderRight: '1px solid #7a6362',
  };

  const tableHeaderStyleA: React.CSSProperties = {
    textAlign: 'center',
    color: '#f2f2f2',
    backgroundColor: 'rgb(96, 125, 145)',
    padding: '5px',
    fontWeight: 'bold',
    borderBottom: '1px solid #7a6362',
    borderTop: '1px solid #7a6362',
    borderLeft: '1px solid #7a6362',
    borderRight: '1px solid #7a6362',
  };

  return (
    <Fragment>
      {loading && (
        <div style={spinnerStyle}>
          <div className="d-flex justify-content-center align-items-center">
            <div className="spinner-border text-primary" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      )}
      <Breadcrumbs mainTitle='Report Audit' title='Report Audit' />
      <Card className={classnames('card-action', { 'card-scroll': scrollInnerCard })}>
        <CardBody>
          <Row>
            <Col md={3} className="mb-1">
              <Label for="audit-select">Audit Select</Label>
              <Select
                id="audit-select"
                className="react-select"
                classNamePrefix="select"
                isClearable
                options={auditData}
                value={auditData.find((option) => option.value === selectedAudit)}
                onChange={(option: SingleValue<OptionType>) => {
                  setSelectedAudit(option?.value || null);
                  // Clearing the audit selection clears the displayed log
                  if (!option) {
                    setAuditData1([]);
                    setShowResults(false);
                    setScrollInnerCard(false);
                  }
                }}
              />
              {auditSelectError && <div className="text-danger">{auditSelectError}</div>}
            </Col>
            <Col md={3} className="mb-1">
              <Label for="start-date-picker" >Start Date</Label>
              <br />
              <ReactDatePicker
                id="start-date-picker"
                className="form-control"
                selected={oneWeekBeforePicker}
                onChange={(date: Date | null) => setOneWeekBeforePicker(date)}
                dateFormat="yyyy-MM-dd"
                isClearable

              />
              {startDateError && <div className="text-danger">{startDateError}</div>}
            </Col>
            <Col md={3} className="mb-1">
              <Label for="end-date-picker">End Date</Label>
              <br />
              <ReactDatePicker
                id="end-date-picker"
                className="form-control"
                selected={currentDatePicker}
                onChange={(date: Date | null) => setCurrentDatePicker(date)}
                dateFormat="yyyy-MM-dd"
                isClearable
              />
              {endDateError && <div className="text-danger">{endDateError}</div>}
            </Col>
            <Col md={3} >
              <Label for="action-select">Action</Label>
              <Select
                id="action-select"
                className="react-select"
                classNamePrefix="select"
                isClearable
                options={Action}
                value={Action.find((option) => option.value === selectedAction)}
                onChange={(option: SingleValue<OptionType>) => setSelectedAction(option?.value || null)}
              />
            </Col>
            <Col xs={12} className='text-center mt-2 pt-50'>
              <div
                className={classnames('customizer', {
                  open: submit,
                })}
              >
                <button
                  onClick={() => {
                    setScrollInnerCard(true);
                    if (!selectedAudit) {
                      setAuditSelectError('Please select Table Name');
                      return;
                    }
                    handleSubmit();
                  }}
                  className='rounded-circle customizer-toggle d-flex align-items-center justify-content-center'
                >
                  <Search size={14} />
                </button>
              </div>
            </Col>
          </Row>
          {showResults && (
            <div className="result-container">
              {auditData1.length > 0 ? (
                <Table bordered>
                  <thead>
                    <tr>
                      <th style={tableHeaderStyleA}>UserName</th>
                      <th style={tableHeaderStyleA}>Modified</th>
                      <th style={tableHeaderStyleA}>Data</th>
                      <th style={tableHeaderStyleA}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {auditData1.map((data, index) => (
                      <tr key={index}>
                        <td style={tableDataStyle}>{data.UserName}</td>
                        <td style={tableDataStyle}>{data.Modified}</td>
                        <td style={tableDataStyle}>{renderJsonDataTable(data.JsonData, data.Action, data.Parentid)}</td>
                        <td style={tableDataStyle}>{data.Action}</td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <div><center>No data available</center></div>
              )}
            </div>
          )}
        </CardBody>
      </Card>
    </Fragment>
  );
};

export default ReportAudit;
